import { render, staticRenderFns } from "./GymHead.vue?vue&type=template&id=766d72b0&scoped=true"
import script from "./GymHead.vue?vue&type=script&lang=js"
export * from "./GymHead.vue?vue&type=script&lang=js"
import style0 from "./GymHead.vue?vue&type=style&index=0&id=766d72b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766d72b0",
  null
  
)

export default component.exports